import { packageLoader } from './core/registry'

// This named export of all the types could be useful to pull in / re-export from other packages
export * as CoreTypes from './core/types'
export * from './core/types'

export { PlatformComponent } from './core/components'
export type { PlatformComponentProps } from './core/components'

export { VERSION } from './constants'

export {
  registerComponent,
  registerComponentWithJsDocs,
  registerPageBlock,
} from './core/helpers'
export { findComponentMetadataFromJson } from './core/helpers/metadata'

export { globalEventBus, EventBus, ChildEventBus } from './core/events'

export {
  componentLoader,
  getUniqueId,
  createGlobalContext,
  pageBlockRegistry,
} from './core/registry'

export type {
  PageBlockMetadata,
  PageBlockDefinition,
  PageBlockEntry,
} from './core/registry'

export {
  ApiClientV1,
  ActionRequestResult,
  ActionTaskStatus,
  RuleViolationsApiClient,
  PolicyEngineApiClient,
  isWarming,
} from './core/api'

export type {
  AvatarSize,
  RuleViolation,
  RuleViolationFilter,
  RuleViolationLink,
  RuleViolationStatus,
  RuleViolationSortBy,
  RuleViolationSortField,
  RuleViolationRuleIdsFilter,
  RuleViolationAssignedToFilter,
  RuleIdInclude,
  SearchRuleViolationsRequest,
  SearchRuleViolationsResponse,
  FindByTargetIdsRequest,
  FindByTargetIdsResponse,
  Decision,
  DecisionRequest,
  DecisionRequestProposedAction,
  DecisionReason,
  DecisionRuleHit,
  Disposition,
  PolicyEvaluateOptions,
  PolicyEvaluation,
  UnbaselinedDomain,
  WarmingResult,
} from './core/api'
export type {
  IList,
  IFilter,
  IViewOverride,
  IExecuteBulkActionRequest,
  IApiResource,
  ActionRequestResultOk,
  ActionRequestResultError,
  ActionTaskPending,
  ActionTaskInProgress,
  ActionTaskCompleted,
  ActionTask,
  ActionTaskInput,
  UiApiClientV1,
  TemplateUiApiClientV1,
} from './core/api'

export { CacheFactory } from './core/api/v1/client/ui/services/cache'
export type { Cache } from './core/api/v1/client/ui/services/cache'

export {
  buildFieldsFromDotNotation,
  GraphQLProvider,
  useGraphQLFetch,
  useGraphQLResourceFetch,
  useGraphQLMutation,
  useGraphQLSubscription,
  executeGraphQLResourceFetch,
  executeGraphQLFetch,
} from './core/api/v1/client/graphql'

export {
  hasFeature,
  hasDevFlag,
  buildPlatformUrl,
  hasPermission,
  hasPermissions,
  hasRole,
  hasRoles,
  handleNotFound,
  getSupportEmail,
  getOrgPreferences,
  getAppPreferences,
  getShowIfFieldsFor,
  setPlatformGlobals,
  getPlatformGlobals,
  getPlatformGlobal,
} from './core/globals'

export {
  HorizonProvider,
  HorizonRootProvider,
  EventBusContextProvider,
  ApiClientContextProvider,
  HostContextProvider,
  RegistryContextProvider,
  ApiClientProvider,
  EventBusProvider,
  EventBusScope,
  PageContext,
  PageStateContext,
  ComponentPageStateContext,
  PageStateProvider,
  ComponentPageStateProvider,
  UserContext,
  UserProvider,
} from './core/context'

export type {
  HorizonProviderProps,
  HorizonConfig,
  RegistryContextValue,
  HostContextValue,
  HorizonInitFn,
  ComponentState,
  PageStateContextValue,
  PageStateSnapshot,
  ComponentPageStateContextValue,
  UserContextValue,
  UserMetadata,
} from './core/context'

export {
  useRegistryContext,
  useEventBusContext,
  useApiClientContext,
  useApiClientInit,
  useDataSchema,
  useHostContext,
  useHorizonContext,
  useApiClient,
  useEventBus,
  useGlobalEventBus,
  usePage,
  usePageStateContext,
  usePageStateSelector,
  useComponentByRole,
  useComponentPageState,
  useUser,
  useUniqueId,
  useConfigurationVariable,
  fetchConfigurationVariable,
  useFunctionInstalled,
  fetchInstalledPackages,
  isFunctionInstalled,
  useAvatar,
  useRuleViolations,
  useRuleViolationsByTargetId,
  usePolicyEvaluation,
} from './core/hooks'

export type {
  ApiClientInitOptions,
  IConfigurationVariable,
  IFetchConfigurationVariableOptions,
  IUseConfigurationVariableOptions,
  InstalledPackage,
  IFetchInstalledPackagesOptions,
  IUseFunctionInstalledOptions,
  UseFunctionInstalledResult,
  UseRuleViolationsProps,
  UseRuleViolationsResult,
  UseRuleViolationsByTargetIdProps,
  UseRuleViolationsByTargetIdResult,
  UsePolicyEvaluationResult,
  PolicyEvaluationStatus,
} from './core/hooks'

export const addPackage = packageLoader.addPackage

export * from './core/utils'

export {
  parseQueryToFilter,
  DEFAULT_EMPTY_FILTER,
} from './lucene-query/parse-query-to-filter'
